if (!customElements.get('image-zoom-modal')) {
  class ZoomModal extends HTMLElement {
    constructor() {
      super();
      this.selector = this.dataset.imageWrapperSelector;
      this.isOpen = false;
    }

    connectedCallback() {
      if (this.closest('main')) document.body.insertBefore(this, document.body.firstChild);

      window.addEventListener('click', (e) => {
        const clickedElement = e.target.closest(this.selector) || e.target.closest('[data-zoom-action]');
        if(!clickedElement) return;

        if(!this.isOpen && e.target.closest(this.selector)) {
          this.triggerImage = e.target.closest('img');
          this.images = [...e.target.closest(this.selector).querySelectorAll('img')];
          this.open();
          setTimeout(() => {
            this.focus();
            trapFocusInDialog(this)
          }, 100);
          return;
        }

        const {
          zoomAction: action,
        } = clickedElement.dataset;

        switch (action) {
          case 'close':
          this.close();
          break;
          default: break;
        }

      })
    }

    close() {
      const fadeOut = function() {
        this.style.position = null;
        this.style.display = null;
        this.removeEventListener('transitionend', fadeOut);
      }

      this.addEventListener('transitionend', fadeOut, false);

      this.isOpen = false;
      this.innerHTML = '';
      document.body.classList.remove('overlay');

      this.style.opacity = null;
    }

    open() {
      const startingIndex = this.images.findIndex(x => x === this.triggerImage);
      this.isOpen = true;
      document.body.classList.add('overlay');
      this.innerHTML = `
      <div class="relative w-full" role="dialog" tabindex="0" >
        <button data-zoom-action="close" type="button" aria-label="close modal" class="absolute bg-primaryLight block top-0 right-0 p-7.5 flex items-center transition duration-200 md:hover:text-accent1 z-10 animation-spin">
          <div class="w-3 h-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="currentColor" viewBox="0 0 12 12" aria-hidden="true">
              <path d="M10.795 0 6 4.795 1.2 0 0 1.2 4.795 6 0 10.795 1.2 12 6 7.205 10.795 12 12 10.795 7.205 6 12 1.2z"/>
            </svg>
          </div>
        </button>
        <swiper-image-gallery data-starting-index="${startingIndex || 0}" class="flex" role="region" aria-label="carousel">
          <div class="w-1/4 p-10 h-screen overflow-hidden hidden md:block">
            <div data-thumbs class="h-4/5">
              <div class="swiper-wrapper flex flex-col flex-wrap items-center justify-start gap-1.5 w-[max-content!important] text-transparent">
                ${this.images.map((img) => `
                  <div class="swiper-slide w-[72px!important] h-[78px!important] bg-secondaryLight cursor-pointer" role="button" tabindex="0">
                    <img class="transition duration-200 border border-current block w-full h-full object-center object-cover" loading="lazy" height="${img.height}" width="${img.width}" alt="${img.alt}" src="${img.src}" />
                  </div>
                `).join('')}
              </div>
            </div>
          </div>
          <div class="w-full md:w-1/2 h-screen flex justify-center items-center role="region">
            <div data-gallery class="h-screen bg-secondaryLight aspect-[3/4] overflow-hidden">
              <ul class="swiper-wrapper cursor-zoom-in">
                ${this.images.map((img) => `
                  <li class="swiper-slide">
                    <div data-zoom-container class="swiper-zoom-container" role="button" tabindex="0">
                      <img class="block w-full h-full object-center object-contain" loading="lazy" height="2400" width="2400" alt="${img.alt}" src="${img.src.replace('width=1200', 'width=2400')}" />
                    </div>
                  </li>
                `).join('')}
              </ul>
            </div>
          </div>

          ${this.images.length > 1 ? `
            <div class="flex items-center w-max gap-8 left-1/2 transform -translate-x-1/2 absolute bottom-0 bg-primaryLight z-20 px-5 py-8">
              <button class="disabled:opacity-20 md:hover:enabled:text-accent1" aria-label="previous slide" data-prev>
                <span class="block w-4 h-3 transform rotate-180">
                  <svg xmlns="http://www.w3.org/2000/svg" data-name="Group 490" width="100%" height="100%" viewBox="0 0 8 14" aria-hidden="true">
                    <defs>
                      <clipPath id="dpuo5a2tba">
                      <path data-name="Rectangle 50" d="M0 0h8v14H0z"/>
                      </clipPath>
                    </defs>
                    <path fill="currentColor" data-name="Path 23" d="M1.351 14 0 12.658 5.693 7 0 1.342 1.351 0 7.72 6.329a.945.945 0 0 1 0 1.342z" style="clip-path:url(#dpuo5a2tba)"/>
                  </svg>
                </span>
              </button>
              <div data-pagination></div>
              <button class="disabled:opacity-20 md:hover:enabled:text-accent1" aria-label="next slide" data-next>
                <span class="block w-4 h-3">
                  <svg xmlns="http://www.w3.org/2000/svg" data-name="Group 490" width="100%" height="100%" viewBox="0 0 8 14" aria-hidden="true">
                    <defs>
                      <clipPath id="dpuo5a2tba">
                        <path data-name="Rectangle 50" d="M0 0h8v14H0z"/>
                      </clipPath>
                    </defs>
                    <path fill="currentColor" data-name="Path 23" d="M1.351 14 0 12.658 5.693 7 0 1.342 1.351 0 7.72 6.329a.945.945 0 0 1 0 1.342z" style="clip-path:url(#dpuo5a2tba)"/>
                  </svg>
                </span>
              </button>
            </div>
          ` : ''}
        </swiper-image-gallery>
      </div>
      `;
      this.style.display = 'block';
      this.style.position = 'fixed';
      setTimeout(() => { this.style.opacity = 1 }, 10);
    }
  }

  customElements.define('image-zoom-modal', ZoomModal);
}